(function($){
  var active_season = '';
  var climate_change = 'false';

  var demands = {
    population: 0,
    farming: 0,
    fishing: 0,
    public: 0,
    recreation: 0,
    wildlife: 0,
  };

  $(document).ready(function(){
    $('#climateChangeToggle').prop('checked', false);
    $('#climateChangeToggle').prop('disabled', true);

    $('.demand-popover').popover({
      container: 'body'
    });

    $('.season').on('click', function(){
      var t = $(this);
      $('.season').removeClass('active');
      t.addClass('active');
      active_season = t.data('season');
      $('#climateChangeToggle').prop('disabled', false);
      $('.climate-change-control-container .select-season').hide();
      $('.climate-change-control-container .season-selected').show();
      showSeasonSupply();
    });

    $('#climateChangeToggle').on('change', function(){
      var t = $(this);
      if(t.prop('checked')){
        climate_change = 'true';
        $('.season').addClass('cc');
      } else {
        climate_change = 'false';
        $('.season').removeClass('cc');
      }
      showSeasonSupply();
    });

    $('.demand-group .plus-button').on('click', function(e){
      var t = $(this);
      var group = t.parents('.demand-group').data('group');
      addDemand(group);
    });

    $('.demand-group .minus-button').on('click', function(e){
      var t = $(this);
      var group = t.parents('.demand-group').data('group');
      removeDemand(group);
    });

    $('.demand-group').on('click', function(e){
      $('.demand-group').not(this).removeClass('active').popover('hide');
      var group = $(this).data('group');
      $('.demand-container .icon').removeClass('active');
      $(this).addClass('active');
      $('.demand-container .icon[data-group="' + group +'"]').addClass('active');
      if($(this).data('toggle') == 'collapse'){
        var target = $(this).data('target');
        if($(e.target).parents('.plus-button').length || $(e.target).parents('.minus-button').length){
          // always show if the plus or minus is clicked
          $(target).collapse('show');
        } else {
          $(target).collapse('toggle');
        }
        e.preventDefault();
        e.stopPropagation();
      }
    });

    $('.demand-container .icon').on('click', function(){
      var group = $(this).data('group');
      $('.demand-container .icon').not(this).removeClass('active');
      $(this).addClass('active');
      $('.demand-group').removeClass('active');
      $('.demand-group').popover('hide');
      $('.demand-group[data-group="' + group + '"]').addClass('active').trigger('click');
    });

    position_landscape_content();
  });

  $(window).on('resize', function(){
    position_landscape_content();
  });

  function position_landscape_content(){
    var landscape_svg = $('#landscape-svg');
    var svg_top = landscape_svg.offset().top;

    $("#headline-row").css('top', $('#headline-top').offset().top - svg_top);
    $("#land-water-row").css('top', $('#land-water-top').offset().top - svg_top);
    $("#connected-row").css('top', $('#connected-top').offset().top - svg_top);
    $("#farm-fish-row").css('top', $('#farm-fish-top').offset().top - svg_top);
    $("#cities-row").css('top', $('#cities-top').offset().top - svg_top);
  }

  function showSeasonSupply(){
    $('.season-overlay').removeClass('active');
    $('.season-overlay[data-season="' + active_season + '"][data-cc="' + climate_change + '"]').addClass('active');
  }

  function addDemand(group){
    if(demands[group] <= 2){
      for(var key in demands){
        if(key == group){
          demands[key] = math.add(demands[key], 1);
        } else {
          demands[key] = math.subtract(demands[key], math.fraction(1/5));
        }
      }
    }
    // console.log(demands);
    adjustGroupDemands();
  }

  function removeDemand(group){
    if(demands[group] >= -2){
      for(var key in demands){
        if(key == group){
          demands[key] = math.subtract(demands[key], 1);
        } else {
          demands[key] = math.add(demands[key], math.fraction(1/5));
        }
      }
    }
    // console.log(demands);
    adjustGroupDemands();
  }

  var translation_factor = 15;
  function adjustGroupDemands(){
    var total = 0;
    for(var key in demands){
      var val = demands[key];
      total += math.abs(val);
      var supply_el = $('.water-supply[data-group="' + key + '"]');
      
      var transform = val * -translation_factor;
      if(val < 0){
        supply_el.addClass('insufficient');
      } else {
        supply_el.removeClass('insufficient');
      }
      supply_el.css('transform', 'translateY(' + transform + 'px)')

    }

    var mobile_supply_el = $(".mobile-water-supply");
    var mobile_transform = total * translation_factor/2;
    if(total > 0){
      mobile_supply_el.addClass('insufficient');
    } else {
      mobile_supply_el.removeClass('insufficient');
    }
    mobile_supply_el.css('transform', 'translateY(' + mobile_transform + 'px)');
  }
})(jQuery);